import React from 'react';
import CAppTitle from '../../../app/components/CAppTitle';
import { Box } from '@mui/material';
import VFaqArticleList from '../views/VFaqArticleList';
import useFaqArticlesInvestor from '../hooks/useFaqArticlesInvestor';
import { Helmet } from 'react-helmet';
import langFaq from '../langs/langFaq';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../auth/contexts/AuthContext';

const PFaqInvestor = () => {
	const faqArticles = useFaqArticlesInvestor();
	const { t } = useTranslation();
	const authContext = useAuthContext();
	return (
		<>
			<Helmet>
				<title>
					{authContext.authContext === 'employee' ? '[E] ' : ''} {t(langFaq.title.tag)} -{' '}
					{authContext.currentCompany ? authContext.currentCompany.name : ''}
				</title>
			</Helmet>
			<CAppTitle title={t(langFaq.title.tag)} subtitle={t(langFaq.subtitle.tag)} />
			<Box sx={{ paddingBottom: '50px' }}>
				<VFaqArticleList articles={faqArticles} />
			</Box>
		</>
	);
};

export default PFaqInvestor;
